import React from 'react';
// custom imports
import '../../../assets/css/TopBar.css';
// 3rd party imports
import { Dropdown, Menu, } from 'antd';
import { AuthClient } from '@dfinity/auth-client';
const TopBar = () => {
    const menu = (React.createElement(Menu, null,
        React.createElement(Menu.Item, { key: "0" },
            React.createElement("span", { role: "button", tabIndex: 0, onClick: async () => { const authClient = await AuthClient.create(); await authClient.logout(); window.location.reload(); } }, "Logout"))));
    return (React.createElement("div", { className: "top-bar-container" },
        React.createElement("div", { className: "top-bar-left-section" },
            React.createElement("div", null, "clandestine")),
        React.createElement("div", { className: "top-bar-right-section" },
            React.createElement(Dropdown, { overlay: menu },
                React.createElement("span", { className: "dot" })))));
};
export default TopBar;
